var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyImgFallbackCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 102,
    viewBox: "0 0 104 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 52,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "172%",
    height: "172%",
    x: "-36%",
    y: "-36%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 50,
    r: 50,
    fill: "#13191F",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M63 41a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H41a1 1 0 0 1-1-1V42a1 1 0 0 1 1-1h22zm-15.023 9.165L42 53.58V57h20v-5.277l-5.504 3.145a1 1 0 0 1-.905.044l-.121-.064-7.493-4.683zM62 43H42v8.276l5.504-3.144a1 1 0 0 1 .905-.044l.121.064 7.493 4.683L62 49.418V43zm-6 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM33.707 67.293a1 1 0 0 1 .083 1.32l-.083.094-7 7a1 1 0 0 1-1.497-1.32l.083-.094 7-7a1 1 0 0 1 1.414 0zm38 0l7 7a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 1.414-1.414zm7-43a1 1 0 0 1 .083 1.32l-.083.094-7 7a1 1 0 0 1-1.497-1.32l.083-.094 7-7a1 1 0 0 1 1.414 0zm-52 0l7 7a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 1.414-1.414z",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyImgFallbackCircle);
export default __webpack_public_path__ + "static/media/grey-img-fallback-circle.ab9d31dbd98fc61d2df49932b774e056.svg";
export { ForwardRef as ReactComponent };